<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 8.5V23.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15 14C14.1716 14 13.5 14.6716 13.5 15.5V16.5C13.5 17.3284 14.1716 18 15 18H20C20.8284 18 21.5 17.3284 21.5 16.5V15.5C21.5 14.6716 20.8284 14 20 14H15Z" fill="currentColor"/>
</svg>
